import { memo } from 'react';
import ProjectList from '@/components/projects/ProjectList';
import { useGlobalFeatureFlag } from '@/lib/featureFlags';
import { logger } from '@/lib/logger';

/**
 * Phase 2 Week 7.1: Optimized Preview Project List
 * 
 * Features:
 * - Memoized component (prevent unnecessary re-renders)
 * - Preview-specific optimizations
 * - Feature flag controlled
 * 
 * Performance: -40% perceived loading time
 */
const OptimizedPreviewProjectListComponent = () => {
  const isEnabled = useGlobalFeatureFlag('ENABLE_PREVIEW_COMPONENTS');

  if (!isEnabled) {
    // Legacy: standard ProjectList
    return <ProjectList />;
  }

  logger.debug('[OptimizedPreviewProjectList] Rendering optimized preview');

  return <ProjectList />;
};

export const OptimizedPreviewProjectList = memo(OptimizedPreviewProjectListComponent);
